import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const AnimatedText = ({ text, mode = 'wave', repeat = false,
                      fontSize=30}) => {
  const [isAnimating, setIsAnimating] = useState(true);

  useEffect(() => {
    if (mode === 'wave' && !repeat) {
      setTimeout(() => setIsAnimating(false), text.length * 200);
    }
  }, [mode, repeat, text.length]);

  return (
    <span style={{ display: 'inline-flex', gap: '0.25rem' }}>
      {text.split(' ').map((word, wordIndex) => (
        <span key={wordIndex} style={{ display: 'inline-flex' }}>
          {word.split('').map((letter, letterIndex) => (
            <span
              key={letterIndex}
              style={{
                display: 'inline-block',
                fontSize,
                animation: isAnimating
                  ? `wave 1s ease-in-out ${(wordIndex + letterIndex) * 0.1}s ${repeat ? 'infinite' : 'forwards'}`
                  : 'none',
              }}
            >
              {letter}
            </span>
          ))}
        </span>
      ))}

      <style jsx>{`
        @keyframes wave {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-5px); /* Adjust for desired wave height */
          }
        }
      `}</style>
    </span>
  );
};

AnimatedText.propTypes = {
  text: PropTypes.string.isRequired,
  mode: PropTypes.string,
  repeat: PropTypes.bool,
};

export default AnimatedText;
